import { reportCalendarAbuseLink } from 'owa-locstrings/lib/strings/reportcalendarabuselink.locstring.json';
import { termsLink } from 'owa-locstrings/lib/strings/termslink.locstring.json';
import { privacyLink } from 'owa-locstrings/lib/strings/privacylink.locstring.json';
import { helpLink } from 'owa-locstrings/lib/strings/helplink.locstring.json';
import { feedbackLink } from 'owa-locstrings/lib/strings/feedbacklink.locstring.json';
import { proactiveMessageHeader } from './MiniMavenPane.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { loadMiniMavenHelpWidget } from 'owa-help-charm';
import { getAlchemyInsights, AlchemyInsightsResponse } from 'owa-alchemy';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { lazyLaunchInAppFeedback } from 'owa-uservoice';
import { isWorkloadSupported } from 'owa-workloads';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import { observer } from 'mobx-react';
import HeaderPaneProps from './HeaderPaneProps';
import { isFeatureEnabled } from 'owa-feature-flags';

// TODO: Task 659 -- Provide context-sensitive help divs
const Helpdiv: string = 'https://go.microsoft.com/fwlink/?linkid=853225';
const Privacydiv: string = 'https://go.microsoft.com/fwlink/?linkId=521839';
const Termsdiv: string = 'https://www.microsoft.com/en-us/servicesagreement';
const styles = require('./HeaderPane.scss');
const isMiniMavenWidgetEnabled: boolean = isFeatureEnabled('help-miniMavenWidget');

@observer
export default class MiniMavenPane extends React.Component<HeaderPaneProps, {}> {
    private proactiveHeaderDiv: HTMLElement;
    private openHelpTab = () => {
        window.open(Helpdiv, '_blank');
    };

    private openPrivacyTab = () => {
        window.open(Privacydiv, '_blank');
    };

    private openTermsTab = () => {
        window.open(Termsdiv, '_blank');
    };

    private launchInAppFeedback = () => {
        lazyLaunchInAppFeedback.importAndExecute();
    };

    private async bindAlchemyContent(hostingDivElement: HTMLDivElement) {
        if (hostingDivElement) {
            const alchemyResponse: AlchemyInsightsResponse = await getAlchemyInsights(
                'helpPane',
                'EmptyProactiveMessage'
            );

            if (
                alchemyResponse &&
                alchemyResponse.Insights &&
                alchemyResponse.Insights.length > 0 &&
                alchemyResponse.Insights[0].Description
            ) {
                hostingDivElement.innerHTML =
                    this.proactiveHeaderDiv.innerHTML + alchemyResponse.Insights[0].Description;
                hostingDivElement.style.display = 'block';
            }
        }
    }

    render() {
        const isAlchemySolutionEnabled: boolean = isFeatureEnabled('help-proactiveMessaging');

        return (
            <div className={styles.helpPaneDiv}>
                {isAlchemySolutionEnabled && (
                    <div
                        className={styles.alchemyHostingDiv}
                        ref={ref => this.bindAlchemyContent(ref)}>
                        <div ref={ref => (this.proactiveHeaderDiv = ref)}>
                            <div className={styles.alchemyHeaderDiv}>
                                <Icon className={styles.titleIcon} iconName={'Info'} />
                                <p className={styles.alchemyHeader}>
                                    {loc(proactiveMessageHeader)}
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {isMiniMavenWidgetEnabled && (
                    <div className={styles.miniMavenWidgetHostingDiv}>
                        <div ref={ref => loadMiniMavenHelpWidget(ref, this.props.onDismiss)}>
                            <Spinner className={styles.miniMavenWidgetLoading} />
                        </div>
                    </div>
                )}
                <div className={styles.actionsDiv}>
                    <ul className={styles.actions}>
                        <li>
                            <CommandButton
                                onClick={this.launchInAppFeedback}
                                text={loc(feedbackLink)}
                                className={styles.action}
                            />
                        </li>
                        {!isMiniMavenWidgetEnabled && (
                            <li>
                                <CommandButton
                                    onClick={this.openHelpTab}
                                    text={loc(helpLink)}
                                    className={styles.action}
                                />
                            </li>
                        )}
                        <li>
                            <CommandButton
                                onClick={this.openPrivacyTab}
                                text={loc(privacyLink)}
                                className={styles.action}
                            />
                        </li>
                        <li>
                            <CommandButton
                                onClick={this.openTermsTab}
                                text={loc(termsLink)}
                                className={styles.action}
                            />
                        </li>
                        {isWorkloadSupported(OwaWorkload.Calendar) && (
                            <li>
                                <CommandButton
                                    href="https://www.microsoft.com/concern/calendarabuse"
                                    text={loc(reportCalendarAbuseLink)}
                                    className={styles.action}
                                />
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}
